var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('index-page',{attrs:{"parentData":{ grid: _vm.grid, path: _vm.path, grid_key: _vm.grid_key, report_class: _vm.report_class }},on:{"set-loading":_vm.setLoading}}),_c('ui-prompts',{attrs:{"parentData":{ areas_key: _vm.grid }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }